<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title">{{$t('message.title_buddy_bot_api_delete_bot')}}</div>
                <hr class="dialog-hr">
                <div class="confirm-body" v-html="$t('message.info_delete_object', { objectName: this.targetBotInfo.displayName })">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="$emit('delete')">{{$t("message.button_ok")}}</el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['targetBotInfo']
}
</script>

<style scoped>


</style>
